module.exports = __webpack_public_path__ + "static/media/9D.fcd9623d.svg";